import tw from 'tailwind-styled-components'

const NotifyContainer = tw.div`
md:mx-12
mx-6
md:mb-8
my-4
bg-white
boxShadow
rounded-lg
min-w-[380px]
relative
`
const NotifyMain = tw.form`
flex
flex-col
justify-center
`
const NotifyContent = tw.div`
grid 
grid-cols-3 
w-full
mt-2
`
export {
    NotifyContainer,
    NotifyMain,
    NotifyContent,
}
